import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './ProposalQuote.css';
import Number from 'components/shared/text/Number';
import ComplexNumberInput from 'components/shared/input/ComplexNumberInput';

import { updateProposalValue } from 'actions/admin/work-orders/details/proposal';

class ProposalQuote extends Component {
  static propTypes = {
    itemId: PropTypes.number.isRequired,
    amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
      .isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    contractor: PropTypes.string.isRequired,
    taskNumber: PropTypes.number.isRequired,
    taskTrade: PropTypes.string.isRequired,
    values: PropTypes.shape({
      fee: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      insurance: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      markup: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    }),
  };

  static defaultProps = {
    values: {
      fee: null,
      insurance: null,
      markup: null,
    },
  };

  handleInputBlur = (valueKey, value) => {
    // Round value
    this.props.dispatch(
      updateProposalValue(this.props.itemId, valueKey, Math.round(value))
    );
  };

  handleInputChange = (valueKey, value) => {
    this.props.dispatch(
      updateProposalValue(this.props.itemId, valueKey, value)
    );
  };

  variance = () => {
    const variance =
      ((parseFloat(this.props.values['fee']) +
        parseFloat(this.props.values['insurance']) +
        parseFloat(this.props.values['markup']) +
        parseFloat(this.props.value || 0)) /
        parseFloat(this.props.amount)) *
      100;
    return variance;
  };

  render() {
    const showCheck = this.props.withCheck !== undefined;
    const props = this.props;

    return (
      <div className="proposal-quote">
        <table className="proposal">
          <colgroup>
            <col />
            <col />
            <col />
          </colgroup>
          <tbody>
            <tr>
              <td>
                <div
                  className={showCheck ? 'with-check-text' : ''}
                >{`Task # ${props.taskNumber}`}</div>
              </td>
            </tr>
            <tr>
              <td>
                <div className={showCheck ? 'with-check-text' : ''}>
                  {props.taskTrade}
                </div>
              </td>
              <td>{props.contractor}</td>
              <td>
                <Number value={props.amount} format="$0,0.00" />
              </td>
            </tr>
            <tr>
              <td />
              <td>{props.value && 'Value'}</td>
              <td>
                {props.value && (
                  <Number value={props.value || ''} format="$0,0.00" />
                )}
              </td>
            </tr>
            <tr>
              <td colSpan={3}>
                <ComplexNumberInput
                  label="Markup"
                  value={props.values['markup']}
                  onValueBlur={this.handleInputBlur.bind(this, 'markup')}
                  onValueChange={this.handleInputChange.bind(this, 'markup')}
                />
                <ComplexNumberInput
                  label="Fee"
                  value={props.values['fee']}
                  onValueBlur={this.handleInputBlur.bind(this, 'fee')}
                  onValueChange={this.handleInputChange.bind(this, 'fee')}
                />
                <ComplexNumberInput
                  label="Insurance"
                  value={props.values['insurance']}
                  onValueBlur={this.handleInputBlur.bind(this, 'insurance')}
                  onValueChange={this.handleInputChange.bind(this, 'insurance')}
                />
              </td>
            </tr>
            <tr>
              <td colSpan={5}>
                {this.variance() < 15 && (
                  <span className="variance-warning">
                    Warning: Variance is lower than 15%, please adjust markup,
                    fee and insurance
                  </span>
                )}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

export default connect()(ProposalQuote);



// WEBPACK FOOTER //
// ./src/components/admin/work-orders/details/proposals/EditProposalQuote.js